import React from 'react';
import { Database, PenLine, Calculator, Building2, Ticket } from 'lucide-react';

const STYLES = {
  xd: 'bg-blue-50 text-blue-700 border-blue-200',
  xd_b2b: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  manual: 'bg-amber-50 text-amber-700 border-amber-200',
  calculado: 'bg-violet-50 text-violet-700 border-violet-200',
  registo: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

const ICONS = {
  xd: Database,
  xd_b2b: Building2,
  manual: PenLine,
  calculado: Calculator,
  registo: Ticket,
};

const LABELS = {
  xd: 'XD',
  xd_b2b: 'XD B2B',
  manual: 'Manual',
  calculado: 'Calculado',
  registo: 'Registo',
};

export function DataOriginBadge({ type = 'xd', label, className = '' }) {
  const Icon = ICONS[type] || ICONS.xd;
  const displayLabel = label || LABELS[type] || type;
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold border ${STYLES[type] || STYLES.xd} ${className}`}
      data-testid={`origin-badge-${type}`}
    >
      <Icon className="h-3 w-3" />
      {displayLabel}
    </span>
  );
}

export function DataOriginLegend({ className = '', expanded = false }) {
  return (
    <div className={`flex flex-wrap items-center gap-3 text-[10px] ${className}`} data-testid="origin-legend">
      <DataOriginBadge type="xd" />
      <span className="text-muted-foreground">POS XD direto</span>
      {expanded && (
        <>
          <DataOriginBadge type="xd_b2b" />
          <span className="text-muted-foreground">XD B2B especial</span>
          <DataOriginBadge type="registo" />
          <span className="text-muted-foreground">Registo proprio</span>
        </>
      )}
      <DataOriginBadge type="manual" />
      <span className="text-muted-foreground">Input utilizador</span>
      <DataOriginBadge type="calculado" />
      <span className="text-muted-foreground">Derivado do sistema</span>
    </div>
  );
}

/**
 * Matriz de Origem de Dados por Seccao (Auditoria Fev/2026)
 * Referencia operacional para tooltips e ajuda contextual.
 */
export const ORIGEM_SECCOES = {
  'Cafe':        { tipo: 'xd', fonte: 'Armazem WH2', filtro: 'FT/FR/FS', desc: 'XD limpo — 100% vendas reais via Terminal 2' },
  'Loja Avelal': { tipo: 'xd', fonte: 'Terminal T1',  filtro: 'FT/FR/FS', desc: 'XD limpo — 99.9% vendas reais' },
  'Loja Satao':  { tipo: 'xd', fonte: 'Terminal T6',  filtro: 'FT/FR/FS', desc: 'XD limpo — 100% vendas reais' },
  'Escritorio':  { tipo: 'xd_b2b', fonte: 'Terminal T4', filtro: 'FT/FR/FS', desc: 'XD especial B2B — vendas institucionais a preco reduzido. Fora de pontos e rankings.' },
  'Restaurante': { tipo: 'manual', fonte: 'Manual', filtro: 'N/A', desc: 'Manual — sem vendas reais no XD. Terminal 3 usado apenas para compras a fornecedores.' },
  'Raspadinhas': { tipo: 'registo', fonte: 'Registo proprio', filtro: 'N/A', desc: 'Registo proprio — valores inseridos via modulo dedicado.' },
};
